export default __webpack_public_path__ + "static/media/ucsblogo.72f369b6.png";